const shouldShowAdditionalDetails = (messages, index) => {
  if (index < 0 || index >= messages.length) return false;
  const current = messages[index];
  const next = messages[index + 1];
  if (current.type === "Typing" && index === messages.length - 1) {
    return true;
  }
  const showableTypes = ["chatbot", "agent", "user"];
  if (!showableTypes.includes(current.type)) {
    return false;
  }
  if (next) {
    const isSameSender = next.type === current.type && next.senderDisplayName === current.senderDisplayName;
    if (isSameSender) {
      const currentTime = new Date(current.timestamp).getTime();
      const nextTime = new Date(next.timestamp).getTime();
      const diffInMinutes = Math.abs(nextTime - currentTime) / (1e3 * 60);
      if (diffInMinutes > 1) {
        return true;
      }
      return false;
    }
  }
  return true;
};
const getConversationEventMessage = (action, agentName) => {
  if (action === "add") {
    return `${agentName} joined.`;
  }
  return `${agentName} left.`;
};

export { getConversationEventMessage, shouldShowAdditionalDetails };
//# sourceMappingURL=src-utils-component-utils.js.map
